import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class UserInfoService {

  constructor(private _http: HttpClient) {
  }

  getUserInfo(id: number) {
    return this._http.get<any>('api/a/employee/userInfo/' + id);
  }

  getProfileInfo(id: number) {
    return this._http.get<any>('api/a/employee/profileInfo/' + id);
  }

  getUsersInfo(params: any) {
    return this._http.post<any>('api/a/employee/all/userInfoList', params);
  }

  getAllActiveUsersInfo() {
    return this._http.post<any>('api/a/employee/all/allUserInfoList', "");
  }

  getAllModeratorsInfo() {
    return this._http.post<any>('api/a/employee/all/allModeratorsList', "");
  }

  getAllRegionAdminsList(regionId) {
    return this._http.post<any>('api/a/employee/admin/list/by/region/' + regionId, "");
  }


  save(params: any) {
    return this._http.post<any>('api/a/employee/user/save', params);
  }

  profileSave(params: any) {
    return this._http.post<any>('api/a/employee/profile/save', params);
  }

  deleteUser(id: number) {
    return this._http.get<any>('api/a/employee/user/delete/' + id);
  }

  generateLoginPassword(userIds: number[]) {
    return this._http.post<any>('api/a/employee/generateLoginPassword', userIds);
  }

  uploadImage(formData: FormData, currentPhotoId: string, userId: number) {
    return this._http.post<any>(`api/a/employee/photo/upload/` + userId + '/' + currentPhotoId,
      formData, {headers: {'noContentType': 'true'}});
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/services/user-information.service.ts